'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'jai20enmaths-cms/documents/LOAD';
var LOAD_SUCCESS = 'jai20enmaths-cms/documents/LOAD_SUCCESS';
var LOAD_FAIL = 'jai20enmaths-cms/documents/LOAD_FAIL';

var initialState = {
  loaded: false,
  editing: {},
  saveError: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result.items,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.documents && globalState.documents.loaded;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/document');
    } // params not used, just shown as demonstration
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/documents.js
// module id = 596
// module chunks = 0